export const defaultConfig = {
  baseURL: '/api',
  headers: { needToken: true },
}
